
export enum ProjectStatus {
  ONGOING = 'Ongoing',
  COMPLETED = 'Completed'
}

export interface ProjectStat {
  label: string;
  value: string;
}

export interface Project {
  id: string;
  title: string;
  location: string;
  status: ProjectStatus;
  description: string;
  imageUrl: string;
  stats: ProjectStat[];
}

export interface CarouselItem {
  id: string;
  imageUrl: string;
  description?: string;
}

export interface CompanyStats {
  yearsExperience: number;
  projectsCompleted: number;
  kilometersBuilt: string;
}

export interface BrandingSettings {
  logoUrl: string;
  heroImageUrl: string;
}

export interface AboutSettings {
  foundationTitle: string;
  foundationDescription: string;
  foundationImage: string;
  missionTitle: string;
  missionDescription: string;
  missionPoints: string[];
  visionTitle: string;
  visionDescription: string;
  visionPoints: string[];
  profileTitle: string;
  profileDescription: string;
  profileImage: string;
}

export interface Career {
  id: string;
  title: string;
  department: string;
  location: string;
  type: 'Full-time' | 'Contract';
  description: string;
}

export interface Brand {
  id: string;
  name: string;
  abbreviation?: string;
  imageUrl: string;
  addedAt: string;
}

export interface Speciality {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
}

export interface ContactSettings {
  phone: string;
  email: string;
  address: string;
  mapUrl?: string;
}

export interface UserRecord {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string;
  isApproved: boolean;
  role: 'admin' | 'user';
  addedAt: any;
}

export type ViewState = 'home' | 'about' | 'projects' | 'careers' | 'clients' | 'contact' | 'ai-advisor' | 'admin';
